import {
  cityValidation,
  emailValidation,
  stringValidation,
  zipValidation,
} from 'src/services/validation';
import * as Yup from 'yup';

// The order of these is important due to the validation running sequentially.
// Whatever order these are in is the order that the input focusing will occur in if there is an erorr.
export default Yup.object().shape({
  owner: Yup.object().shape({
    name: stringValidation(),
    email: emailValidation(),
    primaryPhone: stringValidation(),
    secondaryPhone: Yup.string(),
    address: Yup.object().shape({
      street: stringValidation(),
      city: cityValidation(),
      state: stringValidation(),
      zip: zipValidation(),
    }),
  }),
});
